"use client";

import { createContext, useContext } from "react";

// The visitor's device class as the server guessed it from the User-Agent: "mobile", "desktop", or undefined for
// tablets and unknown agents (their width can fall on either side of the `lg` breakpoint). Set once in the root
// layout from image_device_server(), so the server render and the hydration pass read the same value.
// Core keeps the same value in its own ImageDeviceContext but does not export it; this is jument's copy.
const ServerDeviceContext = createContext(undefined);

export const ServerDeviceProvider = ({ value, children }) => (
	<ServerDeviceContext.Provider value={value || undefined}>{children}</ServerDeviceContext.Provider>
);

export const useServerDevice = () => useContext(ServerDeviceContext);
